import isEmpty from 'lodash-es/isEmpty'

import { useNotification } from '../../../../hooks'
import { useUserProfileContext } from '../useUserProfileContext'

import { getUserProfileHeaderEditSubmitErrors } from './useUserProfileHeaderEditSubmit.utils'

export function useUserProfileHeaderEditSubmit() {
  const { handleAddErrorNotification } = useNotification()

  const { handleCloseModal, handleUpdateEntity } = useUserProfileContext()

  async function handleEditSubmit({ payload, setErrors, setSubmitting }) {
    return handleUpdateEntity(payload)
      .then(handleCloseModal)
      .catch(({ response }) => {
        setSubmitting(false)

        if (isEmpty(response?.data)) {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        } else {
          setErrors(getUserProfileHeaderEditSubmitErrors(response.data))
        }
      })
  }

  return {
    handleEditSubmit,
  }
}
